import { render, staticRenderFns } from "./PopitPrize.vue?vue&type=template&id=5d7b2f5e&scoped=true&"
import script from "./PopitPrize.vue?vue&type=script&lang=js&"
export * from "./PopitPrize.vue?vue&type=script&lang=js&"
import style0 from "./PopitPrize.vue?vue&type=style&index=0&id=5d7b2f5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7b2f5e",
  null
  
)

export default component.exports